'use client';

import { createContext } from 'react';

// Shared between app.tsx (provider) and the composer (consumer, in
// components/assistant-ui/thread.tsx). When the server requires auth and the
// user is signed out, the composer must open the sign-in view instead of
// firing a turn that the serving guard would 401 — so the "not authenticated"
// error bubble never appears. `requestAuth` opens that view and arms a pending
// send, so the typed message goes out automatically once the user is in.
export interface AuthGate {
  // True only when auth is required AND the user is not signed in.
  needsAuth: boolean;
  // Open the sign-in / create-account view and remember the pending send.
  requestAuth: () => void;
}

export const AuthGateContext = createContext<AuthGate>({
  needsAuth: false,
  requestAuth: () => {},
});
